// region Sentry types re-mapping to avoid dependency on @sentry/browser
export declare type Extra = unknown;
export declare type Extras = Record<string, Extra>;

type CaptureContext = {
    extra: Extras;
};

interface EventHint {
    captureContext?: CaptureContext;
}
// endregion

abstract class ErrorReport {
    public abstract getName(): string;
    public enabledForGuest = false;
    public sentryInfo: EventHint;
    public appInstanceName = 'RWC::Error';

    constructor(public error: Error, public extra: Record<string, unknown>) {
        this.error.name = this.getName();
        this.sentryInfo = {
            captureContext: {
                extra: this.extra,
            },
        };
    }
}

// TODO: RCV-87180
export const handleErrorReport = (errorOrReport: ErrorReport | Error): void => {
    const sentryErrorReporterInstance = window[Symbol.for('sentryErrorReporterInstance')];

    if (errorOrReport instanceof ErrorReport) {
        sentryErrorReporterInstance?.captureException(
            errorOrReport.error,
            errorOrReport.sentryInfo,
            errorOrReport.enabledForGuest
        );
        return;
    }

    sentryErrorReporterInstance?.captureException(errorOrReport);
};

export class JoinMeetingErrorReport extends ErrorReport {
    public enabledForGuest = true;
    public getName(): string {
        return `${this.appInstanceName}::JoinMeetingError`;
    }
}

export class BridgeErrorReport extends ErrorReport {
    public enabledForGuest = true;
    public getName(): string {
        return `${this.appInstanceName}::BridgeError`;
    }
}

export class FederatedModuleErrorReport extends ErrorReport {
    public getName(): string {
        return `${this.appInstanceName}::FederatedModuleError`;
    }
}

export class DynamicBrandingErrorReport extends ErrorReport {
    public getName(): string {
        return `${this.appInstanceName}::DynamicBrandingError`;
    }
}

export class CapturingUserMediaErrorReport extends ErrorReport {
    public getName(): string {
        return `${this.appInstanceName}::CapturingUserMediaError`;
    }
}

export class PlatformErrorReport extends ErrorReport {
    public enabledForGuest = true;
    public getName(): string {
        return `${this.appInstanceName}::PlatformError`;
    }
}
